import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getMappedProductReviewData } from "containers/creditReview/details/tabs/executiveSummary/sections/productReview/getMappedProductReviewData";
import { getErrorMessage } from "helpers";
import { creditReviewDetailsService } from "services";
import { uiActions } from "store";
import { ProductReviewDto, ErrorResponse } from "types";

type useGetProductReviewByCreditReviewIdQueryProps = {
	creditReviewId: string;
};

const useGetProductReviewByCreditReviewIdQuery = ({
	creditReviewId,
}: useGetProductReviewByCreditReviewIdQueryProps) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["creditProductReview", creditReviewId],
		() =>
			creditReviewDetailsService.getProductReview({
				creditReviewId,
			}),
		{
			select: (data: ProductReviewDto) => {
				return getMappedProductReviewData(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!creditReviewId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetProductReviewByCreditReviewIdQuery;
